import SelectInput from "components/inputs/selectInput"
import TextInput from "components/inputs/textInput"
import ToggleInput from "@/components/inputs/toggleInput"
import { CategoriesSortBy } from "hooks/useCategories"
import React from "react"
import { useTranslation } from "react-i18next"
import Collapse from "@/components/collapse/Collapse"
import { ReactComponent as FilterIcon } from 'assets/icons/filter.svg'
import InputGroup from "@/components/inputs/InputGroup"

interface CategoryFilterProps {
    filterQuery: string
    setFilterQuery: (v: string) => void
    allowedSortBy: readonly string[]
    sortBy: string
    setSortBy: (v: "categoryId" | "name" | "description") => void
    sortDirection: "asc" | "desc"
    setSortDirection: (v: "asc" | "desc") => void
    displayDeleted: boolean
    setDisplayDeleted: (v: boolean) => void
    isLoading?: boolean
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({
    filterQuery,
    setFilterQuery,
    allowedSortBy,
    sortBy,
    setSortBy,
    sortDirection,
    setSortDirection,
    displayDeleted,
    setDisplayDeleted,
    isLoading
}) => {
    const { t } = useTranslation()
    return (
        <div className="flex flex-col gap-y-4">
            <Collapse textOpen={t(`labelHideFilters`)} textClosed={t(`labelShowFilters`)} icon={<FilterIcon />}>
                <TextInput
                    label={t("labelFilterKeywords")}
                    value={filterQuery}
                    onChange={e => setFilterQuery(e.target.value)}
                    disabled={isLoading}
                />
                <InputGroup forcedColumns={true}>
                    <SelectInput
                        label={t("labelSortBy")}
                        value={sortBy}
                        onChange={e => setSortBy(e.target.value as CategoriesSortBy)}
                        disabled={isLoading}
                    >
                        {allowedSortBy.map(field => (
                            <option key={field} value={field}>{t(`column${field.charAt(0).toUpperCase() + field.slice(1)}`)}</option>
                        ))}
                    </SelectInput>
                    <SelectInput
                        label={t("labelSortDirection")}
                        value={sortDirection}
                        onChange={e => setSortDirection(e.target.value as "asc" | "desc")}
                        disabled={isLoading}
                    >
                        <option value="asc">{t("labelAscending")}</option>
                        <option value="desc">{t("labelDescending")}</option>
                    </SelectInput>
                </InputGroup>
                <ToggleInput 
                    label={t("labelDisplayDeleted")} 
                    checked={displayDeleted} 
                    onChange={e => setDisplayDeleted(e.target.checked)} 
                    disabled={isLoading} 
                />
            </Collapse>
        </div>
    )
}

export default CategoryFilter
